import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Dialog } from "primereact/dialog";
import { Tooltip } from 'primereact/tooltip';
import { Sidebar } from 'primereact/sidebar';
import { OverlayPanel } from 'primereact/overlaypanel';

import moment from "moment"
import _ from 'lodash'

import "./index.css"

import { Button, TextAreaField, InputSwitchField, DropDownField, TextInputField } from '../../helpers';
import Table from '../../helpers/Table';

import Loading from '../../common/Loading';
import DocView from '../../common/DocView';
import CopyToClipboard from '../../common/CopyToClipboard';
import PMCompanyName from '../../common/PMCompanyName';
import ButtonGroup from '../../common/ButtonGroup';

import ApprovalMaterialItem from './Components/ApprovalMaterialItem';
import SearchBar from './Components/SearchBar';
import DocumentsSplitView from '../../common/DocumentsSplitView';
import QuickApprovalReq from './Components/QuickApprovalReq';

import {
    fetchMaterialCategories,
    fetchMaterialBrands,
    fetchMaterialUoms,
    fetchTDSSections,
    fetchCompanyCreditPeriods
} from '../../services/redux/reducers/commonThunk';

import { processApprovalInstance } from '../../services/api/approvalInstances';
import { raiseToast } from '../../services/redux/reducers/toast/toast';
import { fetchApprovalList, updateSearchParams, updateApprovalInstancesData, setIsSearchVisible } from '../../services/redux/reducers/approvalData/approvalData'
import { fetchApprovalTypes, fetchApprovals, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getMaterialMasterTempItemByMaterialId } from '../../services/api/materialMasterTemp';
import { duplicateMaterialIdFromBuyerReqAndPO } from '../../services/api/materialMasterTemp';

import { DATE_TIME_FORMAT } from '../../constants'
import { isMobile } from '../../utils';


const ApprovalInstances = () => {
    const [visibleAddRemark, setVisibleAddRemark] = useState(false)
    const [updateRemarks, setProcessedRemarks] = useState('')
    const [selectedInstanceId, setselectedInstanceId] = useState(null)
    const [actionId, setActionId] = useState(null)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [parentDocLinkView, setParentDocLinkView] = useState(false)
    const [remarkDialogTitle, setRemarkDialogTitle] = useState('')
    const [approvalMaterialItem, setApprovalMaterialItem] = useState({})
    const [buyerReqAndPOMaterialIds, setBuyerReqAndPOMaterialIds] = useState([])
    const [visibleApprovalMaterialItem, setVisibleApprovalMaterialItem] = useState(false)
    const [enableServicePurchase, setEnableServicePurchase] = useState(false)
    const [visibleDocumentSplitView, setVisibleDocumentSplitView] = useState(false)
    const [tdsSectionId, setTDSSectionId] = useState(null)
    const [paymentTerms, setPaymentTerms] = useState(null)


    const paginationParams = useSelector(state => state.approvalData.paginationParams)
    const searchParams = useSelector(state => state.approvalData.searchParams)
    const approvalInstancesData = useSelector(state => state.approvalData.approvalInstancesData)
    const approvalUsers = useSelector(state => state.approvalData.approvalUsers)
    const isLoading = useSelector(state => state.approvalData.loading)
    const isSearchVisible = useSelector(state => state.approvalData.isSearchVisible)
    const isSearchActive = useSelector(state => state.approvalData.isSearchActive)
    const statusList = useSelector((state) => state.common.status)
    const approvals = useSelector((state) => state.common.approvals)
    const userDetails = useSelector((state) => state.userDetails)
    const activeUserRole = userDetails.activeUserRoleDetails
    const materialCategory = useSelector((state) => state.common.materialCategories)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const materialUOMData = useSelector(state => state.common.materialUOMs)
    const companyCreditPeriods = useSelector((state) => state.common.companyCreditPeriods)

    const userId = userDetails?.userId
    const usersList = userDetails?.PMCompanyDetails?.companyUsers
    const tdsSections = useSelector(state => state.common.tdsSections)

    const isMobileDevice = isMobile()
    const op = useRef(null)

    const dispatch = useDispatch()
    const location = useLocation()

    useEffect(() => {
        const fromDate = new Date((new Date()).getTime() - 15 * 24 * 60 * 60 * 1000)
        const toDate = new Date()
        const updatedSearchParams = { ...searchParams, fromDate: fromDate, toDate: toDate }
        dispatch(updateSearchParams({ ...updatedSearchParams }))

        const queryParams = new URLSearchParams(location.search)
        if (queryParams.get('docNo')) {
            dispatch(fetchApprovalList({ ...paginationParams, ...searchParams, searchBy: 'docNo', searchText: queryParams.get('docNo'), companyId: activeUserRole.companyId, docNo: queryParams.get("docNo") }))
        }
        else if (queryParams.get('parentDocNo')) {
            dispatch(fetchApprovalList({ ...paginationParams, ...searchParams, searchBy: 'parentDocNo', searchText: queryParams.get('parentDocNo'), companyId: activeUserRole.companyId, parentDocNo: queryParams.get('parentDocNo') }))
        }
        else if (queryParams.get('approvalInstanceId')) {
            dispatch(fetchApprovalList({ ...paginationParams, ...searchParams, searchBy: 'approvalInstanceId', searchText: queryParams.get('approvalInstanceId'), companyId: activeUserRole.companyId, approvalInstanceId: queryParams.get('approvalInstanceId') }))
        }
        else {
            dispatch(fetchApprovalList({ ...paginationParams, ...searchParams, pageNo: 0, companyId: activeUserRole.companyId }))
        }
        dispatch(fetchApprovalTypes())
        dispatch(fetchApprovals())
        dispatch(fetchStatus())
        dispatch(fetchMaterialCategories())
        dispatch(fetchMaterialBrands())
        dispatch(fetchMaterialUoms())
        dispatch(fetchTDSSections())
        dispatch(fetchCompanyCreditPeriods())
    }, [])

    const handleActionClick = (rowData, ActionId) => {
        let remarksTitle = ''
        if (ActionId == 1) {
            remarksTitle = 'Please add remarks before approving the request!'
            
            // 'Ready to Accept: Add Remarks!' : 'Provide Rejection Remarks!'
            setRemarkDialogTitle(remarksTitle)
        }
        else {
            remarksTitle = 'Please add remarks before rejecting the request!'
            setRemarkDialogTitle(remarksTitle)
        }
        
        if (rowData.approvedMetrics?.tdsSectionId && rowData.approvedMetrics?.tdsSectionId !== 1) {
            setEnableServicePurchase(true)
            setTDSSectionId(rowData.approvedMetrics?.tdsSectionId)
        } else if (rowData.approvedMetrics?.paymentTerms) {
            setPaymentTerms({...rowData.approvedMetrics?.paymentTerms})
        }

        setselectedInstanceId(rowData.approvalInstanceId)
        setVisibleAddRemark(true)
        setActionId(ActionId)
    }

    const handlePageChange = async (e) => {
        let getApprovalInstancesParams = {
            ...searchParams,
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            companyId: activeUserRole.companyId
        }

        if (getApprovalInstancesParams.searchBy !== "all") {
            getApprovalInstancesParams[getApprovalInstancesParams.searchBy] = getApprovalInstancesParams.searchText.trim()
        }

        dispatch(fetchApprovalList({ ...getApprovalInstancesParams }))
    }

    const handleSubmitAction = async (approvalInstanceId, ActionId) => {

        let relatedApprovalInstance = approvalInstancesData.find(eachApproval => eachApproval.approvalInstanceId === selectedInstanceId)
        let relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === relatedApprovalInstance.approvalId)
        
        if (enableServicePurchase && tdsSectionId === 1) {
            return dispatch(raiseToast({ severity: 'error', summary: 'Approval', detail: "Please select TDS", life: 3000 }))
        }

        if([13, 19].includes(relatedApproval.approvalTypeId)){ //if([38, 39].includes(relatedApprovalInstance.approvalId)){ // APPROVAL_CHANGE
            if (paymentTerms) {
                let total_payment_percentage = 0
                if (paymentTerms.payAdvPO || paymentTerms.payAdvDelivery || paymentTerms.payPDCDelivery || paymentTerms.payOnDelivery || paymentTerms.payCredit) {
                    if (paymentTerms.payAdvPO) {
                        paymentTerms.payAdvPO = parseFloat(paymentTerms.payAdvPO)
                        total_payment_percentage += paymentTerms.payAdvPO
                    }
                    if (paymentTerms.payAdvDelivery) {
                        paymentTerms.payAdvDelivery = parseFloat(paymentTerms.payAdvDelivery)
                        total_payment_percentage += paymentTerms.payAdvDelivery
                    }
                    if (paymentTerms.payOnDelivery) {
                        paymentTerms.payOnDelivery = parseFloat(paymentTerms.payOnDelivery)
                        total_payment_percentage += paymentTerms.payOnDelivery
                    }

                    if ((paymentTerms.payCredit && paymentTerms.payCredit != 0) || (paymentTerms.payPDCDelivery && paymentTerms.payPDCDelivery != 0)) {
                        if (paymentTerms.payCredit && paymentTerms.payCredit != 0) {
                            paymentTerms.payCredit = parseFloat(paymentTerms.payCredit)
                            total_payment_percentage += paymentTerms.payCredit
                        }
                        if (paymentTerms.payPDCDelivery && paymentTerms.payPDCDelivery != 0) {
                            paymentTerms.payPDCDelivery = parseFloat(paymentTerms.payPDCDelivery)
                            total_payment_percentage += paymentTerms.payPDCDelivery
                        }
                        if (!paymentTerms.creditPeriodId) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Please select credit period", life: 3000 }))
                        }
                    } else {
                        delete paymentTerms.creditPeriodId
                    }
                }else{
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please enter payment terms", life: 3000 }))
                }
                
                if (paymentTerms?.payAdvPO || paymentTerms?.payAdvDelivery || paymentTerms?.payPDCDelivery || paymentTerms?.payOnDelivery || paymentTerms?.payCredit) {
                    if (total_payment_percentage !== 100 && total_payment_percentage != 0) {
                        return dispatch(raiseToast({ severity: 'warn', detail: "Total percentage of payment terms should be 100", life: 3000 }))
                    }
                }
            }
            else {
                return dispatch(raiseToast({ severity: 'warn', detail: "Please enter payment terms", life: 3000 }))
            }
        }
        if (updateRemarks === '') {
            return dispatch(raiseToast({ severity: 'error', summary: 'Approval', detail: "Remark can't be empty!", life: 3000 }))
        }
        setVisibleAddRemark(false)
        setIsPageLoading(true)

        const data = {
            processedRemarks: updateRemarks
        }
        setProcessedRemarks('')

        if (ActionId === 1) {
            data["statusId"] = 9;
        } else {
            data["statusId"] = 8;
        }

        if (relatedApprovalInstance && relatedApproval.approvalTypeId === 18) { // if (relatedApprovalInstance && relatedApprovalInstance.approvalId === 35) { //APPROVAL_CHANGE
            data.tdsSectionId = tdsSectionId
        }

        if (relatedApprovalInstance && [13, 19].includes(relatedApproval.approvalTypeId)) { // if (relatedApprovalInstance && [38, 39].includes(relatedApprovalInstance.approvalId)) { // APPROVAL_CHANGE
            data.paymentTerms = paymentTerms
        }

        if(relatedApprovalInstance && relatedApproval.approvalTypeId === 15){ //   if(relatedApprovalInstance && relatedApprovalInstance.approvalId === 28){ //APPROVAL_CHANGE
            data.buyerReqAndPOMaterialIds = buyerReqAndPOMaterialIds
        }

        data.docNo = relatedApprovalInstance.docNo
        data.parentDocNo = relatedApprovalInstance.parentDocNo
        data.sellerCompanyName = relatedApprovalInstance.sellerCompanyName
        data.sellerCompanyId = relatedApprovalInstance.sellerCompanyId
        data.buyerCompanyName = relatedApprovalInstance.buyerCompanyName
        data.buyerCompanyId = relatedApprovalInstance.buyerCompanyId

        if (window.confirm('Are you sure you want to continue?')) {
            setIsPageLoading(true)
            const updatedResponse = await processApprovalInstance(approvalInstanceId, data)
            if (updatedResponse.failure) {
                setIsPageLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: 'Approval', detail: updatedResponse.data.error, life: 3000 }))
            } else {
                setIsPageLoading(false)
                setEnableServicePurchase(false)
                setTDSSectionId(null)
                const updatedList = approvalInstancesData.map((eachApprovalInstanceData) => {
                    if (eachApprovalInstanceData.approvalInstanceId === approvalInstanceId) {
                        return {
                            ...eachApprovalInstanceData,
                            processedBy: updatedResponse.data[1].processedBy,
                            processedTS: updatedResponse.data[1].processedTS,
                            statusId: data["statusId"],
                            processedRemarks: updateRemarks,
                        }
                    } else {
                        return { ...eachApprovalInstanceData }
                    }
                })
                dispatch(updateApprovalInstancesData(updatedList))
                if (ActionId === 1) {
                    dispatch(raiseToast({ severity: 'success', summary: 'Approval', detail: "Request approved.", life: 3000 }))
                }
                else {
                    dispatch(raiseToast({ severity: 'error', summary: 'Approval', detail: "Request rejected.", life: 3000 }))
                }
            }
        }
    }

    const getMaterialItemDetails = async (materialId, selectedApprovalInstanceId) => {
        setIsPageLoading(true)
        const materialDetails = await getMaterialMasterTempItemByMaterialId(materialId)

        setIsPageLoading(false)
        if (materialDetails.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: materialDetails.data.error, life: 3000 }))
        }
        else {
            const material = materialDetails?.data

            if (!material) {
                return dispatch(raiseToast({ severity: 'error', detail: "Material ID not found", life: 3000 }))
            } else {
                let relatedCategory = materialCategory?.find(category => category.categoryId === material.categoryId)
                let relatedBrand = materialBrands?.find(brand => brand.brandId === material.brandId)
                let relatedUom = materialUOMData?.find(uom => uom.UOM === material.UOM)
                setApprovalMaterialItem({ ...material, categoryId: relatedCategory, brandId: relatedBrand, UOM: relatedUom })
                setVisibleApprovalMaterialItem(true)
                setselectedInstanceId(selectedApprovalInstanceId)
                getBuyerReqAndPOMaterialIds(materialId)
            }
        }
    }

    const getBuyerReqAndPOMaterialIds = async(materialId) => {
        setIsPageLoading(true)
        const buyerReqAndPOMaterialIdsResponse = await duplicateMaterialIdFromBuyerReqAndPO(materialId)

            if (buyerReqAndPOMaterialIdsResponse.failure){
                setIsPageLoading(false)
                return dispatch(raiseToast({severity:'error', summary: buyerReqAndPOMaterialIdsResponse.data.error , life: 3000}))
            } else {
                let materialIds = _.uniqBy(_.map(buyerReqAndPOMaterialIdsResponse?.data, "materialId"))
                setBuyerReqAndPOMaterialIds(materialIds)
                setIsPageLoading(false)
            }
    }

    
    const getDocNo = (rowData) => {
        const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === rowData.approvalId)
        if (relatedApproval){
            if ([1, 2, 3, 4, 5, 6].includes(relatedApproval.approvalTypeId)) { //  if ([1, 2, 6, 10, 11, 13, 14, 15, 16, 17, 18, 20].includes(rowData.approvalId)) {// APPROVAL_CHANGE
                return (
                    <div className="flex flex-row">
                        <p className='doc-no' style={{ cursor: "pointer", }} onClick={() => window.open(`/buyer/quotation/${rowData?.docId}`, '_blank')}>{rowData?.docNo}</p>
                        {rowData?.docId && <CopyToClipboard text={rowData?.docNo} />}
                    </div>
                )
            }

            if ([8, 12].includes(relatedApproval.approvalTypeId)) {// if ([19, 24].includes(rowData.approvalId)) {// APPROVAL_CHANGE
                return (
                    <div className="flex flex-row w-100 align-items-center">
                        <p style={{ cursor: 'pointer', color: '#3366cc', textDecoration: 'underline', width: "100%" }} onClick={() => window.open(`/credit_note/${rowData?.docId}`, '_blank')}>CN Preview</p>
                        {/* <i className="pi pi-copy pl-1 doc-copy-icon" onClick={() => handleCopyClick(rowData?.docNo)} ></i> */}
                    </div>
                )
            }
        }

        if (rowData.docNo) {
            return (
                <div className="flex flex-row w-100 align-items-center">
                    <p style={{ cursor: 'pointer', color: '#3366cc', textDecoration: 'underline', width: "100%" }} onClick={() => window.open(`/docs/${rowData?.docNo}`, '_blank')}>{rowData?.docNo}</p>
                </div>
            )
        }

        return (
            <DocView docData={rowData} docLink={rowData.docLink} />
        )
    }

    const getParentDocNo = (rowData) => {
        return (
            <div>
                {
                    rowData.parentDocLink ? <span onClick={() => { setParentDocLinkView(true) }} style={{ cursor: 'pointer', color: '#3366cc', textDecoration: 'underline' }}>
                        {rowData.parentDocNo}
                    </span> : <p style={{ cursor: 'pointer', color: '#3366cc', textDecoration: 'underline' }} onClick={() => window.open(`/docs/${rowData?.parentDocNo}`, '_blank')} > {rowData.parentDocNo}</p>
                }
                <Dialog visible={parentDocLinkView} style={{ width: '80%', height: '80%', backgroundColor: '#f8f8f8', position: "" }} onHide={() => setParentDocLinkView(false)}>
                    <div style={{ width: "100%", height: '100%' }}>
                        <div style={{ width: "100%", height: '100%' }}>
                            <embed className='' src={rowData.parentDocLink} width="100%" height="100%" />
                        </div>
                    </div>
                </Dialog>
            </div>
        )
    }

    const getRaisedBy = (rowData) => {
        const createdByUser = approvalUsers.find(eachUser => eachUser.userId === rowData.createdBy)
        return (
            <>
                <Tooltip target={`.custom-tool-tip-raised-by${rowData.approvalInstanceId}`} position="top" autoHide >
                    <p className='m-0'><b>Raised On:</b>  {moment(new Date(rowData?.createdAt)).format(DATE_TIME_FORMAT)}</p>
                </Tooltip>
                <div className={`custom-tool-tip-raised-by${rowData.approvalInstanceId}`} >{createdByUser?.firstName} {createdByUser?.lastName}</div>
            </>
        )
    }

    const getPrimaryApprover = (rowData) => {
        let primaryApproverUser = usersList.find(user => user.userId == rowData.primaryApprover)
        const secondayApproverUser = usersList.find(user => user.userId == rowData.secondaryUserId)

        let pmCompanyUsers = userDetails.PMCompanyDetails?.companyUsers ? userDetails.PMCompanyDetails.companyUsers : []

        if (activeUserRole.companyId !== activeUserRole.pmCompanyId){
            let activeRoleCompanyUsers = userDetails?.companyDetails?.companyUsers ? userDetails.companyDetails.companyUsers : []
            pmCompanyUsers = [...pmCompanyUsers, ...activeRoleCompanyUsers]

            primaryApproverUser = pmCompanyUsers.find(user => user.userId == rowData.primaryApprover)
        }

        const branchHODUser = null
        pmCompanyUsers.map(eachCompanyUser => {
            if (eachCompanyUser.statusId === 1) {
                eachCompanyUser.userRoles.map(eachUserRole => {
                    if (eachUserRole.branchId === userDetails.branchId && eachUserRole.statusId === 1) {
                        branchHODUser = eachCompanyUser
                    }
                })
            }
        })

        const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === rowData.approvalId)

        if(!relatedApproval){
            return <></>
        }

        if (relatedApproval.approvalRole === "COMPANY ROLE") {
            const primaryApproverRoleId = relatedApproval.primaryApprover

            let branchHODUser = null
            pmCompanyUsers.map(eachCompanyUser => {
                if (eachCompanyUser.statusId === 1) {
                    eachCompanyUser.userRoles.map(eachUserRole => {
                        if (rowData.pmBranchId && eachUserRole.branchId === rowData.pmBranchId && eachUserRole.companyRoleId === primaryApproverRoleId && eachUserRole.statusId === 1) {
                            branchHODUser = eachCompanyUser
                        }
                        if (!rowData.pmBranchId && eachUserRole.companyRoleId === primaryApproverRoleId && eachUserRole.statusId === 1) {
                            branchHODUser = eachCompanyUser
                        }
                    })
                }
            })

            return (
                <>
                    {secondayApproverUser?.firstName && secondayApproverUser?.lastName ? (
                        <Tooltip target={`.custom-tool-tip-primary-approver-${rowData.approvalInstanceId}`} position="top" autoHide >
                            <p className='m-0'> <b>Secondary Approver:</b> {secondayApproverUser?.firstName} {secondayApproverUser?.lastName}</p>
                        </Tooltip>
                    ) : null}

                    <div className={`custom-tool-tip-primary-approver-${rowData.approvalInstanceId}`}>
                        {branchHODUser?.firstName} {branchHODUser?.lastName}
                    </div>
                </>
            )
        }

        if (relatedApproval.approvalRole === "MANAGER") {
            let manager = null
            pmCompanyUsers.map(eachCompanyUser => {
                if (eachCompanyUser.statusId === 1 && eachCompanyUser.userId === rowData.createdBy) {
                    eachCompanyUser.userRoles.map(eachUserRole => {
                        if (rowData.pmBranchId && eachUserRole.branchId === rowData.pmBranchId && eachUserRole.statusId === 1) {
                            const managerId = eachUserRole.managerId
                            manager = pmCompanyUsers.find(obj => obj.userId === managerId)
                        }
                    })
                }
            })

            return (
                <>
                    {secondayApproverUser?.firstName && secondayApproverUser?.lastName ? (
                        <Tooltip target={`.custom-tool-tip-primary-approver-${rowData.approvalInstanceId}`} position="top" autoHide >
                            <p className='m-0'> <b>Secondary Approver:</b> {secondayApproverUser?.firstName} {secondayApproverUser?.lastName}</p>
                        </Tooltip>
                    ) : null}

                    <div className={`custom-tool-tip-primary-approver-${rowData.approvalInstanceId}`}>
                        {manager?.firstName} {manager?.lastName}
                    </div>
                </>
            )
        }

        return (
            <>
                {secondayApproverUser?.firstName && secondayApproverUser?.lastName ? (
                    <Tooltip target={`.custom-tool-tip-primary-approver-${rowData.approvalInstanceId}`} position="top" autoHide >
                        <p className='m-0'> <b>Secondary Approver:</b> {secondayApproverUser?.firstName} {secondayApproverUser?.lastName}</p>
                    </Tooltip>
                ) : null}

                <div className={`custom-tool-tip-primary-approver-${rowData.approvalInstanceId}`}>
                    {primaryApproverUser?.firstName} {primaryApproverUser?.lastName}
                </div>
            </>
        )
    }

    const getStatus = (rowData) => {
        const relatedStatus = statusList.find((status) => status.statusId == rowData.statusId)?.status
        const processedByUser = usersList.find(user => user.userId == rowData.processedBy)
        const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === rowData.approvalId)

        if(!relatedApproval || !relatedStatus){
            return <></>
        }

        return (
            <div className="text-center">
                {rowData.createdBy !== userId && rowData.statusId === 12 ? (
                    <div className="button-container mr-2 text-center">
                        <Button
                            className="accept-button small-btn"
                            onClick={() => handleActionClick(rowData, 1)}
                        >
                            Accept
                        </Button>
                        <Button
                            className="mx-1 reject-button small-btn"
                            onClick={() => handleActionClick(rowData, 0)}
                            disabled={relatedApproval.approvalTypeId === 18} //disabled={rowData.approvalId === 35} //APPROVAL_CHANGE
                        >
                            Reject
                        </Button>
                    </div>
                ) : (
                    <div className="text-center">
                        <Tooltip target={`.custom-tool-tip-${rowData.approvalInstanceId}`} position="top" autoHide >
                            <p className='m-0'><b>APPROVER :</b> {processedByUser?.firstName} {processedByUser?.lastName} <br /> <b>REMARK:</b> {rowData.processedRemarks} <br /> <b>PROCESSED ON:</b> {rowData?.processedTS ? moment(new Date(rowData?.processedTS)).format(DATE_TIME_FORMAT) : null}</p>
                        </Tooltip>
                        <div className={`custom-tool-tip-${rowData.approvalInstanceId} text-center`} >{relatedStatus} </div>
                    </div>
                )}
            </div>
        )
    }

    const getRemarks = (rowData) => {
        const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === rowData.approvalId)
        if(!relatedApproval){
            return <div style={{whiteSpace: "pre-line", textAlign: "left"}}>-</div>
        }

        if (relatedApproval.approvalTypeId === 7) { // if (rowData.approvalId === 12) { //APPROVAL_CHANGE
            return (
                <div style={{whiteSpace: "pre-line"}}>amount: {rowData.approvedMetrics?.amount} {rowData.remarks}</div>
            )
        }
        if (relatedApproval.approvalTypeId === 15) { //if (rowData.approvalId === 28) {// APPROVAL_CHANGE
            return (
                <div>MaterialId: <a onClick={() => getMaterialItemDetails(rowData.materialId, rowData.approvalInstanceId)} style={{ cursor: "pointer", textDecoration: "underline" }}>{rowData.materialId}</a><br />{rowData.remarks}</div>
            )
        }
        if (relatedApproval.approvalTypeId === 27) { // if (rowData.approvalId === 51) { // APPROVAL_CHANGE
            return (
                <div style={{whiteSpace: "pre-line"}}>Payment Mode: {rowData.approvedMetrics?.preferredPaymentMode} {rowData.remarks}</div>
            )
        }
        if (relatedApproval.approvalTypeId === 24){ // if (rowData.approvalId === 45){ //APPROVAL_CHANGE
            return (
                <div style={{whiteSpace: 'pre-line', textAlign: 'left'}}>Location Name: {rowData.approvedMetrics?.name}<br />Coordinates: {rowData.approvedMetrics?.latlong}<br /> {rowData.remarks}</div>
            )
        }

        return (
            <div style={{whiteSpace: "pre-line", textAlign: "left"}}>{rowData.remarks}</div>
        )
    }

    const getBuyerCompanyNameBody = (rowData) => {
        let companyName = rowData["buyerCompanyName"]
        let companyId = rowData["buyerCompanyId"]

        return <PMCompanyName companyName={companyName} companyId={companyId}/>
    }

    const getSellerCompanyNameBody = (rowData) => {
        let companyName = rowData["sellerCompanyName"]
        let companyId = rowData["sellerCompanyId"]

        return (
            <div className="text-center">
                <PMCompanyName companyName={companyName} companyId={companyId}/>
                {
                    rowData["sellerCompanyBranchName"] ? 
                    (
                        <p className="m-0 pt-1" style={{fontSize:"12px"}}>
                            (<span className="text-bold" style={{fontWeight:"bold"}}>Branch Name:</span> {rowData["sellerCompanyBranchName"]})
                        </p>
                    ) 
                    : null
                }
            </div>
        )
    }

    const getUploadedDocBody = (row)=>{
        return(
            <div>
                {
                    row.docProof || row.docLocation ?
                    (
                        <span className='doc-no' style={{cursor: "pointer", color: 'black'}} target='_blank' onClick={() => {setVisibleDocumentSplitView(true); setselectedInstanceId(row.approvalInstanceId)}}>View</span>
                    ) : "-"
                }
            </div>
        )
    }

    const quickApprovalReqBody = (rowData) => {
        const handleWhatsappClick = async (e) => {
            op.current.toggle(e)
            setselectedInstanceId(rowData.approvalInstanceId)
        }

        const isDisabled = [8, 9].includes(rowData.statusId) 
    
        return (
            <button className={`${isDisabled ? 'disabled-icon' : 'cursor-pointer'}`} onClick={handleWhatsappClick} disabled={isDisabled}>
                <i className="pi pi-whatsapp" style={{color: isDisabled ? 'grey' : 'green', fontSize: '20px'}}></i>
            </button>
        )
    }

    const hideQuickApprovalReqPanel = () =>{ 
        if (op.current) {
            op.current.hide()
        }
    }
    
    const tableColumns = [
        {
            header: 'Buyer Company',
            field: 'buyerCompanyName',
            style: { minWidth: "220px" },
            body: getBuyerCompanyNameBody
        },
        {
            header: 'Seller Company',
            field: 'sellerCompanyName',
            style: { minWidth: "220px" },
            body: getSellerCompanyNameBody,
        },
        {
            header: 'Document No',
            field: 'docNo',
            body: getDocNo,
            style: { minWidth: "150px" }
        },
        {
            header: 'Parent Document No',
            field: 'parentDocNo',
            body: getParentDocNo,
            style: { minWidth: "150px" }

        },
        {
            header: 'Raised By',
            field: 'createdBy',
            body: getRaisedBy,
            style: { minWidth: "120px" }
        },
        {
            header: 'Uploaded Doc',
            field: '', 
            style: { minWidth: "90px"},
            body: getUploadedDocBody
        },
        {
            header: 'Remarks',
            field: 'remarks',
            body: getRemarks,
            style: { minWidth: "350px" }
        },
        {
            header: 'Approval Title',
            field: 'approvalTitle',
            style: { minWidth: "190px" }
        },
        {
            header: 'Approval Authority',
            field: 'primaryApprover',
            body: getPrimaryApprover,
            style: { minWidth: "130px" }
        },
        {
            header: 'Status',
            field: 'statusId',
            body: getStatus,
            className: "text-center"
        },
        {
            header: 'Quick Approval Req',
            field: '',
            body: quickApprovalReqBody,
            className: "text-center",
            style: { minWidth: "100px" }
        },
    ]

    const handleTDSChange = (event) => {
        if (event.target.name == 'enableServicePurchase') {
            setEnableServicePurchase(event.value)
            if (event.value) {
                setTDSSectionId(null)
            } else {
                setTDSSectionId(1)
            }
        }

        if (event.target.name == 'tdsSectionId' && enableServicePurchase) {
            setTDSSectionId(event.target.value)
        }
    }

    const handleCloseMaterialItem = () => {
        setVisibleApprovalMaterialItem(false)
        setselectedInstanceId(null)
    }

    const handleCloseRemarksModel = () => {
        setEnableServicePurchase(false)
        setTDSSectionId(null)
        setVisibleAddRemark(false)
    }

    const handlePaymentTermsChange = (event) => {
        paymentTerms[event.target.name] = event.target.value
        setPaymentTerms({...paymentTerms})
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const renderTDSServiceDisplay = () => {
        let relatedTDSSections = tdsSections.filter(eachTDS => enableServicePurchase ? eachTDS.tdsSectionId !== 1 : eachTDS.tdsSectionId === 1)

        return (
            <div className="grid ml-1">
                <div className="flex col-12 mb-1 lg:col-4 md:col-4 lg:mb-4 align-items-center mt-2 p-0">
                    <label className="text-xs mb-1 mr-2"> Enable Services Purchase: </label>
                    <InputSwitchField name="enableServicePurchase" checked={enableServicePurchase} onChange={(event) => handleTDSChange(event)} />
                </div>
                {
                    enableServicePurchase ?
                        <div className="approval-tds-section flex col-12 md:col-8 lg:col-8 pt-0 pl-0">
                            <label htmlFor="tdsSectionId" className="col-12 md:col-4 lg:col-3 mt-2" style={{ fontSize: "12px" }}>
                                TDS Section Type:
                            </label>
                            <div className="col-12 md:col-8 lg:col-9 px-0">
                                <DropDownField className="" style={{ width: '100%' }} name="tdsSectionId" labelText="" options={relatedTDSSections} optionLabel={(eachTDS) => `${eachTDS.tdsSectionName} - ${eachTDS.tdsSectionDesc}`} optionValue="tdsSectionId" value={tdsSectionId} onChange={(event) => handleTDSChange(event)} />
                            </div>
                        </div> : ""
                }
            </div>
        )
    }

    const renderPaymentTermsDisplay = () => {
        let total_payment = 0
        let payment_terms = { ...paymentTerms }
        delete payment_terms.creditPeriodId

        const payment_values = Object.values(payment_terms)

        payment_values.map((value) => {
            if (value) {
                total_payment += parseFloat(value)
            }
        })

        return (
            <>
                <h5 className="text-600">Payment Terms</h5>
                <div className="grid pl-2">
                    <div className="flex flex-column col-12 mb-2 md:col-3 lg:col-3 lg:mb-0">
                        <TextInputField name="payAdvPO" labelText="Adv against PO (%)" keyfilter={"pnum"} value={paymentTerms?.payAdvPO} onChange={(e) => handlePaymentTermsChange(e)} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-3 lg:col-3 lg:mb-0">
                        <TextInputField name="payAdvDelivery" labelText="Adv before Delivery (%)" keyfilter={"pnum"} value={paymentTerms?.payAdvDelivery} onChange={(e) => handlePaymentTermsChange(e)} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-3 lg:col-3 lg:mb-0">
                        <TextInputField name="payPDCDelivery" labelText="PDC on Delivery (%)" keyfilter={"pnum"} value={paymentTerms?.payPDCDelivery} onChange={(e) => handlePaymentTermsChange(e)} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-3 lg:col-3 lg:mb-0">
                        <TextInputField name="payOnDelivery" labelText="Pay against Delivery (%)" keyfilter={"pnum"} value={paymentTerms?.payOnDelivery} onChange={(e) => handlePaymentTermsChange(e)} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-3 lg:col-3 lg:mb-0">
                        <TextInputField name="payCredit" labelText="Credit (%)" keyfilter={"pnum"} value={paymentTerms?.payCredit} onChange={(e) => handlePaymentTermsChange(e)} />
                    </div>
                    {
                        parseInt(paymentTerms?.payCredit) > 0 || parseInt(paymentTerms?.payPDCDelivery) > 0 ?
                            <div className="flex flex-column col-12 mb-2 md:col-2 lg:col-2 lg:mb-0">
                                <DropDownField name="creditPeriodId" labelText="Credit Period" options={companyCreditPeriods} optionLabel="creditPeriodName" optionValue="creditPeriodId" value={paymentTerms?.creditPeriodId} onChange={(e) => handlePaymentTermsChange(e)} />
                            </div> : ""
                    }
                    <div className="flex flex-column col-12 mb-2 md:col-1 lg:col-1 lg:mb-0 mt-2">
                        <p className={`font-bold text-${total_payment == 100 ? 'green-600' : 'red-500'}`}> {total_payment} </p>
                    </div>
                </div>
            </>
        )
    }

    const onHideDocumentSplitView = () => {
        setVisibleDocumentSplitView(false)
    }

    let relatedApprovalInstance = null
    if(selectedInstanceId){
        relatedApprovalInstance = approvalInstancesData.find(eachApproval => eachApproval.approvalInstanceId === selectedInstanceId)
    }

    let isRouted = false
    if (relatedApprovalInstance) {
        isRouted = relatedApprovalInstance.remarks?.toLowerCase().includes('routed') ? true : false
    }

    const actionButtons = [
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]
    
    let relatedApproval = null
    if (relatedApprovalInstance){
        relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === relatedApprovalInstance.approvalId)
    }

    return (
        <div className='flex flex-column'>
            <Loading visible={isPageLoading} />
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">APPROVALS</h4>
                <div className="flex gap-2 justify-content-end mb-2">
                    {/* <Button icon="pi pi-filter" className={`h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>

            <div className='flex flex-row'>
                <div className="approval-instances-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                totalRecords={paginationParams.totalRecords}
                                tableColumns={tableColumns}
                                data={approvalInstancesData}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight="550px"
                                paginator
                                excessPagesFound={paginationParams.excessPagesFound}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>

                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <SearchBar setIsPageLoading={setIsPageLoading}/>
                    </div>
                }
                {
                    isSearchVisible && isMobileDevice && 
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <SearchBar />
                        </Sidebar>
                    </div>
                }
            </div>

            {relatedApprovalInstance && 
                <DocumentsSplitView 
                    doc1={relatedApprovalInstance.docLocation}
                    doc2={relatedApprovalInstance.docProof}
                    visible={visibleDocumentSplitView} 
                    onHide={onHideDocumentSplitView} 
                />
            }

            <Dialog header={remarkDialogTitle} className='mb-3 approval-remark-dialog' visible={visibleAddRemark} style={{ height: 'fit-content', backgroundColor: '#f8f8f8' }} onHide={() => handleCloseRemarksModel()}>
                {
                    actionId === 1 && relatedApproval?.approvalTypeId === 18 ? renderTDSServiceDisplay() : "" //relatedApprovalInstance?.approvalId === 35// APPROVAL_CHANGE
                }
                {
                    actionId === 1 && [13, 19].includes(relatedApproval?.approvalTypeId) ? renderPaymentTermsDisplay() : "" // [38,39].includes(relatedApprovalInstance?.approvalId)//APPROVAL_CHANGE
                }
                <TextAreaField name="processedRemarks" labelText="" value={updateRemarks} rows={5} onChange={e => setProcessedRemarks(e.target.value)} />
                <div className='flex flex-row justify-content-end'>
                    <Button className="mt-2" label="SUBMIT" outlined onClick={() => handleSubmitAction(selectedInstanceId, actionId)} />
                </div>
            </Dialog>
            <Dialog header={`Material Item: ${approvalMaterialItem.materialId} ${isRouted ? "(Routed)" : ""}`} visible={visibleApprovalMaterialItem} style={{ width: '75vw', minHeight: "60%" }} onHide={() => handleCloseMaterialItem()} >
                <ApprovalMaterialItem
                    approvalMaterialItem={approvalMaterialItem}
                    buyerReqAndPOMaterialIds = {buyerReqAndPOMaterialIds}
                />
            </Dialog>
            <OverlayPanel ref={op} style={{ width: '246px', minHeight: "170px" }} dismissable>
                <h4 className="mt-3 ml-2 mb-2" >Raise Quick Approval Request</h4>
                <QuickApprovalReq selectedApproval={relatedApprovalInstance} setIsPageLoading={setIsPageLoading} hideQuickApprovalReqPanel={hideQuickApprovalReqPanel} />
            </OverlayPanel>
        </div>
    )
}

export default ApprovalInstances;